import React ,{ useState } from 'react';
import { createComponent } from '@lit/react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../icon/Icon';
 
import { MdFilledTextField } from '@material/web/textfield/filled-text-field';

import styles from './FilledTextField.module.scss';

const FilledTextFieldComponent = createComponent({
    tagName: 'md-filled-text-field',
    elementClass: MdFilledTextField,
    react: React,
    events: {
        'onChange': 'change',
        'onInvalid': 'invalid',
        'onInput': 'input'
    }
});

interface IComponentProperties {
    disabled?: boolean | undefined, // Apply Disabled state
    label: string, // Defines label text
    name: string, // Defines input name used when the form is submitted
    placeholder: string, // Defines placeholder text
    required?: boolean | undefined, // Apply Required 
    rows?: number | undefined, // Textareas can specify the initial number of rows
    supportingText?: string | undefined, // Supporting text
    type?: 'text' | 'email' | 'number' | 'password' | 'search' | 'tel' | 'url' | 'textarea' | undefined, // Defines input type 
    value?: string|undefined, // Defines input value
    onChange?: (e: any) => void; // Defines onChange event handler
    onInput?: (e: any) => void;
}

function ErrorTrailingIcon(isInvalid: boolean) {
    if (!isInvalid) {
      return <></>;
    }
  
    return (
      <span className={styles['FilledTextField-errorTrailingIcon']} slot="trailing-icon">
        <Icon name="error" ariaHidden={true}></Icon>
      </span>
    );
  }
  
export function FilledTextField(props: IComponentProperties) {
    const [isInvalid, setIsInvalid] = useState(false);
    const [value, setValue] = useState(props.value || '');
    const { t } = useTranslation();
  
    // Events
    function handleChange(e: any) {
      const inputElement: HTMLInputElement = e.target;
  
      setValue(inputElement.value);
  
      inputElement.setCustomValidity('');
  
      setIsInvalid(false);
  
      e.target.reportValidity();
  
      if (props.onChange) {
        props.onChange(e);
      }
    }

    function handleInput (e: any){
      const inputElement: HTMLInputElement = e.target;
  
      setValue(inputElement.value);
  
      console.log('input')
      if (props.onInput){
        props.onInput(e);
      }
    }

    function handleInvalid(e: any) {
      const inputElement: HTMLInputElement = e.target;
      const validityState: ValidityState = inputElement.validity;
  
      if (validityState.valueMissing) {
        inputElement.setCustomValidity('Required');
      }
  
      setIsInvalid(true);
    }
  
    return (
      <div className={styles['FilledTextField-container']}>
        
        <FilledTextFieldComponent
          className={`${styles['FilledTextField']}`}
          aria-label={props.label}
          value={value}
          type={props.type}
          rows={props.rows}
          required={props.required}
          supportingText={props.supportingText}
          name={props.name}
          disabled={props.disabled === true}
          placeholder={t(props.placeholder)}
          onChange={handleChange}
          onInvalid={handleInvalid}
          onInput={handleInput}
          hasTrailingIcon={isInvalid}
        >
          {ErrorTrailingIcon(isInvalid)}
        </FilledTextFieldComponent>
      </div>
    );
  }